export default __webpack_public_path__ + "static/media/self_declared_bot.43129f30.png";